import { useEffect, useState } from 'react';
import { subscribeTenantClasses } from '@services/registry';

export function useTenantClasses({ tenantId }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tenantId) {
            setRows([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        let unsub = () => {};
        try {
            unsub = subscribeTenantClasses({
                tenantId,
                onNext: (next) => {
                    setRows(next);
                    setLoading(false);
                    setError(null);
                },
                onError: (err) => {
                    console.error(err);
                    setError(err);
                    setLoading(false);
                },
            });
        } catch (e) {
            setError(e);
            setLoading(false);
        }
        return () => unsub?.();
    }, [tenantId]);

    return { rows, loading, error };
}

